import styled from "styled-components";

export const Container = styled("div")`
  font-family: "Kanit";
  margin: 3rem 0;
  a {
    padding: 1em 5rem;
    background: rgb(108, 90, 244);
    border: none;
    border-radius: 8px;
    color: #ffffff;
    text-decoration: none;
  }
`;
